import { EntityType } from 'api'
import { Locale, Translation } from 'locale'
import { noop } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { createEntityGetterSelector } from 'selectors/entitySelectors'
import { isNotNil } from 'utils/predicate'
import { SectorDialogComponent } from './SectorDialogComponent'

interface SectorViewDialogProps {
  entityId: string
  onClose?: () => void
}

export const SectorViewDialog: React.FC<SectorViewDialogProps> = ({ entityId, onClose = noop }) => {
  const getSector = useSelector(createEntityGetterSelector(EntityType.PRODUCT_SECTOR))
  const getProduct = useSelector(createEntityGetterSelector(EntityType.PRODUCT))
  const productSector = getSector(entityId)
  const readOnly = {
    name: true,
    productId: true,
    basisConvention: true,
    basketType: true,
    basketCurrency: true,
    billingCurrency: true,
    defaultRepoType: true,
    startConsiderationOverrideThreshold: true,
    supportedRepoTypes: true,
    exDividendDayConvention: true,
    exDividendDays: true,
    defaultNotificationDeadlineTime: true,
    defaultNoticePeriod: true,
    defaultFloatCrystallisationDaysByReferenceRateId: true,
    isExDividend: true
  }
  return isNotNil(productSector) ? (
    <SectorDialogComponent
      productSector={productSector}
      getProduct={getProduct}
      onClose={onClose}
      onSave={noop}
      onUpdate={noop}
      readOnly={readOnly}
      title={Locale.translate(Translation.TC_VIEW_SECTOR)}
      validationIssues={[]}
    />
  ) : null
}
